enum TradeColumn {

    // Symbol / Trade columns
    Symbol = "symbol",
    Price = "price",
    Order = "order",
    Direction = "direction",
    TotalProfit = 'totalProfit',
    TakeProfit = "takeProfit",
    StopLoss = "stopLoss",
    MarketRate = "marketRate",
    OpenRate = "openRate",
    CloseRate = "closeRate",
    CreatedDate = "createdDate",
    CloseDate = "closeDate",
    // Symbol columns
    Chart1d = "chart1d",
    Sell = "sell",
    Buy = "buy",
    Trend = "trend",
    // Activity log columns
    Time = "time",
    Action = "action",
    Description = "description",
    PerformedBy = "performedBy",
    Balance = "balance",
    Amount = "amount",
    TradingEntityId = "tradingEntityId",
    // Other
    Link = "link",
    Icon = "icon",
    ButtonsWithoutPrice = "buttonsWithoutPrice"
}

export {TradeColumn};
